module.exports = __webpack_public_path__ + "static/banner-four-shape4-ad92d2bef7edfff69af8cdfe1cf0454e.png";